module.exports = __webpack_public_path__ + "img/imgriob.d0ff7483.png";